import React, { Component } from "react";

const FEATURES = [
  { icon: "🤖", category: "AI-Powered Tools", title: "Research Any Property in Seconds", body: "Full public records, verified market value, comparable sales, neighborhood health scores, inspection checklists, and AI analysis — all in one report.", stats: [{ val: "AI", label: "Powered" }, { val: "100+", label: "Data Points" }, { val: "Free", label: "To Start" }], accent: "#D4921A" },
  { icon: "🏠", category: "Buy a Home", title: "Search MLS + Off-Market — All in One Place", body: "Find homes you won't see anywhere else. Full transparency, your way.", stats: [{ val: "On+Off", label: "MLS Listings" }, { val: "100%", label: "Transparent" }, { val: "You", label: "In Control" }], accent: "#1A5C40" },
  { icon: "📋", category: "Inspection Analysis", title: "Upload Any Inspection Report — AI Flags Every Risk", body: "AI identifies critical issues, estimates repair costs, and gives you a negotiation strategy — before you make an offer.", stats: [{ val: "PDF", label: "Upload" }, { val: "AI", label: "Risk Analysis" }, { val: "Cost", label: "Estimates" }], accent: "#4A3A6A" },
  { icon: "🎯", category: "Buyer Readiness", title: "Know Your Buying Power Before You Start", body: "Answer 8 quick questions. Get your readiness score, estimated buying power, and a personalized action plan — free, in 2 minutes.", stats: [{ val: "8", label: "Questions" }, { val: "DTI", label: "Calculated" }, { val: "Score", label: "Out of 90%" }], accent: "#7A2A1A" },
  { icon: "💰", category: "Sell Your Home", title: "Sell on Your Terms — No MLS Pressure", body: "List for free, off-market or on. Set your own timeline. Search for matching buyer profiles.", stats: [{ val: "Free", label: "To List" }, { val: "Your", label: "Timeline" }, { val: "Off", label: "MLS Option" }], accent: "#1A5C40" },
  { icon: "🏡", category: "Homeowner Portal", title: "Manage Your Home — Healthy, Wealthy & Wise", body: "Track your home's health, monitor your equity, get maintenance reminders, and access AI-powered advice.", stats: [{ val: "Health", label: "Tracking" }, { val: "Equity", label: "Monitor" }, { val: "AI", label: "Advisor" }], accent: "#D4921A" },
  { icon: "📍", category: "Prospecting Map", title: "Map Every Property — Save, Track & Research", body: "Drop pins on any property while you're in the field. Pull public records instantly, save to your prospecting list.", stats: [{ val: "GPS", label: "Enabled" }, { val: "Public", label: "Records" }, { val: "Save", label: "& Track" }], accent: "#1A2280" },
];

const INTERVAL = 4500;

/* Inject keyframe animations + responsive CSS once */
if (typeof document !== "undefined" && !document.getElementById("mhb-login-panel-styles")) {
  const styleEl = document.createElement("style");
  styleEl.id = "mhb-login-panel-styles";
  styleEl.textContent = `
    @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700;800;900&display=swap');
    @keyframes pulse1 { 0%,100%{transform:scale(1) translate(0,0);opacity:0.6} 50%{transform:scale(1.1) translate(-20px,20px);opacity:1} }
    @keyframes pulse2 { 0%,100%{transform:scale(1) translate(0,0);opacity:0.5} 50%{transform:scale(1.15) translate(20px,-15px);opacity:0.9} }
    @keyframes fadeSlide { 0%{opacity:0;transform:translateY(12px)} 100%{opacity:1;transform:translateY(0)} }
    .mhb-feature-slide { animation: fadeSlide 0.5s ease forwards; }
    .mhb-pill-hover:hover { background:rgba(212,146,26,0.2)!important; border-color:rgba(212,146,26,0.4)!important; color:#FFD98E!important; }

    /* Mobile: compact header, show slide content, hide logo+pills+bottom */
    @media (max-width: 767px) {
      .mhb-login-panel { min-height: auto !important; height: auto !important; }
      .mhb-panel-topbar { padding: 12px 16px 0 !important; }
      .mhb-panel-logo { display: none !important; }
      .mhb-panel-main { padding: 10px 16px 14px !important; }
      .mhb-panel-bottom { display: none !important; }
      .mhb-panel-pills { display: none !important; }
      .mhb-slide-body { display: none !important; }
      .mhb-slide-heading { font-size: 15px !important; margin-bottom: 6px !important; }
      .mhb-slide-stats { gap: 6px !important; }
      .mhb-stat-box { padding: 8px 6px !important; }
      .mhb-stat-val { font-size: 15px !important; }
      .mhb-progress-bar { margin-bottom: 10px !important; }
      .mhb-dots-row { margin-bottom: 10px !important; }
    }

    /* Tablet: hide pills */
    @media (min-width: 768px) and (max-width: 1024px) {
      .mhb-panel-pills { display: none !important; }
    }
  `;
  document.head.appendChild(styleEl);
}

class LoginPanel extends Component {
  constructor(props) {
    super(props);
    this.state = { current: 0, progress: 0, animKey: 0 };
    this.timer = null;
    this.progressTimer = null;
  }

  componentDidMount() { this.startCycle(); }
  componentWillUnmount() { this.stopCycle(); }

  startCycle = () => {
    this.stopCycle();
    this.setState({ progress: 0 });
    const step = (50 / INTERVAL) * 100;
    this.progressTimer = setInterval(() => {
      this.setState((prev) => ({ progress: Math.min(prev.progress + step, 100) }));
    }, 50);
    this.timer = setTimeout(() => {
      this.setState(
        (prev) => ({ current: (prev.current + 1) % FEATURES.length, animKey: prev.animKey + 1, progress: 0 }),
        () => this.startCycle()
      );
    }, INTERVAL);
  };

  stopCycle = () => {
    if (this.timer) clearTimeout(this.timer);
    if (this.progressTimer) clearInterval(this.progressTimer);
  };

  goTo = (idx) => {
    this.stopCycle();
    this.setState({ current: idx, animKey: this.state.animKey + 1, progress: 0 }, () => this.startCycle());
  };

  render() {
    const { current, progress, animKey } = this.state;
    const f = FEATURES[current];

    return (
      <div className="mhb-login-panel" style={{ position:"relative", width:"100%", height:"100%", minHeight:"100vh", background:"linear-gradient(160deg,#0d1260 0%,#1A2280 35%,#1a3a28 75%,#0d2418 100%)", overflow:"hidden", display:"flex", flexDirection:"column", justifyContent:"space-between", fontFamily:"'DM Sans',sans-serif" }}>

        {/* Background effects */}
        <div style={{ position:"absolute", top:"-100px", right:"-80px", width:"380px", height:"380px", borderRadius:"50%", background:"rgba(212,146,26,0.06)", pointerEvents:"none", animation:"pulse1 8s ease-in-out infinite" }} />
        <div style={{ position:"absolute", bottom:"60px", left:"-100px", width:"320px", height:"320px", borderRadius:"50%", background:"rgba(26,92,64,0.12)", pointerEvents:"none", animation:"pulse2 10s ease-in-out infinite" }} />
        <div style={{ position:"absolute", inset:0, backgroundImage:"linear-gradient(rgba(255,255,255,0.025) 1px,transparent 1px),linear-gradient(90deg,rgba(255,255,255,0.025) 1px,transparent 1px)", backgroundSize:"40px 40px", pointerEvents:"none" }} />

        {/* Top bar */}
        <div className="mhb-panel-topbar" style={{ position:"relative", zIndex:2, padding:"28px 32px 0", display:"flex", alignItems:"center", gap:"12px" }}>
          <div className="mhb-panel-logo" style={{ display:"flex", alignItems:"center", gap:"10px" }}>
            <div style={{ width:"40px", height:"40px", background:"rgba(212,146,26,0.2)", border:"1.5px solid rgba(212,146,26,0.4)", borderRadius:"10px", display:"flex", alignItems:"center", justifyContent:"center", fontSize:"20px" }}>🏡</div>
            <div style={{ display:"flex", flexDirection:"column" }}>
              <span style={{ color:"#FFFFFF", fontSize:"14px", fontWeight:"800", lineHeight:"1.2" }}>My Home Buddha</span>
              <span style={{ color:"rgba(255,255,255,0.5)", fontSize:"10px", fontWeight:"600", textTransform:"uppercase", letterSpacing:"0.1em" }}>Healthy · Wealthy · Wise</span>
            </div>
          </div>
          <div style={{ marginLeft:"auto", background:"rgba(212,146,26,0.18)", border:"1px solid rgba(212,146,26,0.4)", borderRadius:"50px", padding:"4px 12px", fontSize:"10px", fontWeight:"800", color:"#D4921A", letterSpacing:"0.08em", textTransform:"uppercase" }}>Powered by AI</div>
        </div>

        {/* Main content */}
        <div className="mhb-panel-main" style={{ position:"relative", zIndex:2, padding:"24px 32px", flex:1, display:"flex", flexDirection:"column", justifyContent:"center" }}>

          {/* Progress bar */}
          <div className="mhb-progress-bar" style={{ height:"2px", background:"rgba(255,255,255,0.1)", borderRadius:"2px", marginBottom:"20px", overflow:"hidden" }}>
            <div style={{ height:"100%", background:"linear-gradient(90deg,#D4921A,#FFD98E)", borderRadius:"2px", transition:"width 0.1s linear", width:`${progress}%` }} />
          </div>

          {/* Slide */}
          <div key={animKey} className="mhb-feature-slide">
            <div style={{ fontSize:"11px", fontWeight:"800", textTransform:"uppercase", letterSpacing:"0.12em", marginBottom:"10px", color:f.accent }}>
              {f.icon}&nbsp;&nbsp;{f.category}
            </div>
            <h2 className="mhb-slide-heading" style={{ fontSize:"clamp(18px,2.2vw,28px)", fontWeight:"900", color:"#FFFFFF", lineHeight:"1.25", marginBottom:"14px", letterSpacing:"-0.02em" }}>
              {f.title}
            </h2>
            <p className="mhb-slide-body" style={{ fontSize:"13px", color:"rgba(255,255,255,0.75)", lineHeight:"1.7", marginBottom:"22px" }}>
              {f.body}
            </p>
            <div className="mhb-slide-stats" style={{ display:"flex", gap:"12px", marginBottom:"24px" }}>
              {f.stats.map((s, i) => (
                <div key={i} className="mhb-stat-box" style={{ flex:1, background:"rgba(255,255,255,0.07)", border:"1px solid rgba(255,255,255,0.12)", borderRadius:"10px", padding:"12px 10px", textAlign:"center" }}>
                  <div className="mhb-stat-val" style={{ fontSize:"18px", fontWeight:"900", color:f.accent, lineHeight:"1", marginBottom:"4px" }}>{s.val}</div>
                  <div style={{ fontSize:"9px", fontWeight:"700", color:"rgba(255,255,255,0.5)", textTransform:"uppercase", letterSpacing:"0.08em" }}>{s.label}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Dots */}
          <div className="mhb-dots-row" style={{ display:"flex", gap:"6px", marginBottom:"20px" }}>
            {FEATURES.map((_, i) => (
              <div key={i} onClick={() => this.goTo(i)} style={{ height:"4px", borderRadius:"2px", cursor:"pointer", transition:"all 0.4s ease", width:i===current?"28px":"6px", background:i===current?"#D4921A":"rgba(255,255,255,0.25)", boxShadow:i===current?"0 0 8px rgba(212,146,26,0.6)":"none" }} />
            ))}
          </div>

          {/* Pills */}
          <div className="mhb-panel-pills" style={{ display:"flex", flexWrap:"wrap", gap:"6px" }}>
            {FEATURES.map((feat, i) => (
              <div key={i} className="mhb-pill-hover" onClick={() => this.goTo(i)} style={{ background:i===current?"rgba(212,146,26,0.25)":"rgba(255,255,255,0.08)", border:i===current?"1px solid rgba(212,146,26,0.5)":"1px solid rgba(255,255,255,0.15)", borderRadius:"50px", padding:"5px 12px", fontSize:"11px", fontWeight:"600", color:i===current?"#FFD98E":"rgba(255,255,255,0.8)", cursor:"pointer", transition:"all 0.2s" }}>
                {feat.icon} {feat.category}
              </div>
            ))}
          </div>
        </div>

        {/* Bottom */}
        <div className="mhb-panel-bottom" style={{ position:"relative", zIndex:2, padding:"16px 32px 28px", borderTop:"1px solid rgba(255,255,255,0.08)" }}>
          <div style={{ fontSize:"11px", color:"rgba(255,255,255,0.4)", textAlign:"center", lineHeight:"1.5" }}>
            Join thousands of buyers, sellers, agents &amp; homeowners on{" "}
            <span style={{ color:"#D4921A", fontWeight:"700" }}>My Home Buddha</span>
            {" "}— the smarter way to buy, sell &amp; manage your home.
          </div>
        </div>
      </div>
    );
  }
}

export default LoginPanel;